import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Theme from "./Theme/index";
import ChangePassword from "./component/LoginLogout/changePassword";
import ForgotPassword from "./component/LoginLogout/forgotPassword";
import ActivatePage from "./component/LoginLogout/activatePage";
import AdminPannelPage from "./component/AdminPannel/admin";
import PriceComponent from "./component/PricingDetail/price";
import Footer from "./component/Footer";
import Header from "./component/Header";
import Accounts from "./component/MyAccount/account";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const [token, setToken] = useState(null);
  const [oddsFormat, setOddsFormat] = useState("EU");
  const [language, setLanguage] = useState("30");
  const [visible, setVisible] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const location = useLocation();

  // 🔹 Listen for online/offline events
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    const checkAuthStatus = () => {
      const storedToken = sessionStorage.getItem("tokenId");
      const expiry = sessionStorage.getItem("expiryId");

      if (storedToken && expiry) {
        const currentTime = Date.now();
        if (currentTime < parseInt(expiry, 10)) {
          setToken(storedToken);
        } else {
          sessionStorage.clear();
          setToken(null);
        }
      } else {
        setToken(null);
      }
    };

    checkAuthStatus();
  }, []);

  useEffect(() => {
    if (location.pathname === "/" && token) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [location.pathname, token]);

  // 🔹 If offline, show "No Internet" Page
  if (!isOnline) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
      <div
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "10px",
          padding: "40px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
          textAlign: "center",
          maxWidth: "400px",
          width: "90%",
        }}
      >
        <div style={{ fontSize: "48px", marginBottom: "15px", color: "#2b3245" }}>
          📡❌
        </div>

        <h2 style={{ color: "#333", marginBottom: "15px" }}>
          No Internet Connection
        </h2>
        <p style={{ marginBottom: "25px", color: "#555", fontSize: "15px" }}>
          Please check your connection and try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "12px 20px",
            fontSize: "16px",
            backgroundColor: "#2b3245",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            width: "50%",
            transition: "background 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#151b2bff")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#151b2bff")}
        >
          Refresh
        </button>
      </div>
    </div>
  );
  }

  // 🔹 Normal app when online
  return (
    <>
      <Header
        oddsFormat={oddsFormat}
        setOddsFormat={setOddsFormat}
        setLanguage={setLanguage}
        language={language}
        setToken={setToken}
        token={token}
        visible={visible}
      />

      <Routes>
        <Route
          path="/pricing"
          element={<PriceComponent setToken={setToken} token={token} />}
        />
        <Route
          path="/account"
          element={<Accounts setToken={setToken} token={token}  />}
        />
        <Route path="/admin" element={<AdminPannelPage />} />

        <Route
          path="/"
          element={
            <Theme language={language} oddsFormat={oddsFormat} setToken={setToken} token={token}/>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/activate" element={<ActivatePage />} />
      </Routes>

      <Footer />
    </>
  );
}

export default AppWrapper;
